import { render, staticRenderFns } from "./DefaultModel.vue?vue&type=template&id=a9ef1312&scoped=true"
import script from "./DefaultModel.vue?vue&type=script&lang=js"
export * from "./DefaultModel.vue?vue&type=script&lang=js"
import style0 from "./DefaultModel.vue?vue&type=style&index=0&id=a9ef1312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ef1312",
  null
  
)

export default component.exports